import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';

import { enqueueError } from '@paragon/notification-tools';

import { updateUser } from '../../actions/userActions';
import { getOrganizationsSorted } from '../../selectors/organizations';
import { loggedInUser, UserFromSelector } from '../../selectors/users';
import { RootState } from '../../store';
import { getAreAnyErrors, validate } from '../user/validate';
import { UserProperties } from './UserProperties';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

interface State {
  readonly user?: UserFromSelector;
}

class EditSelf extends React.Component<Props, State> {
  state: State = {};

  onUserChange = (user: UserFromSelector) => {
    this.setState({ user });
  };

  onSave = () => {
    const updatedUser = { ...this.props.user!, ...this.state.user };
    const areAnyErrors = getAreAnyErrors(updatedUser);

    if (areAnyErrors) {
      this.props.enqueueError('Please fill all required fields');
      return;
    }

    this.props.updateUser(updatedUser);
  };

  render() {
    if (this.props.user == null) return null;
    const user = this.state.user ?? this.props.user;

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: '35%', p: 1 }}>
        <Typography variant="h6">Edit Information</Typography>
        <Divider sx={{ mb: 4 }} />
        <Paper sx={{ p: 2, pt: 0, bgcolor: 'backContrast.main' }} elevation={1}>
          <UserProperties
            user={user}
            organizations={this.props.organizations}
            onChange={this.onUserChange}
            validate={validate}
            showErrors
          />
        </Paper>
        <Button
          sx={{
            mt: 3,
            mb: 1,
            py: 1,
            width: 150,
            color: 'buttonColor.main',
            bgcolor: 'backContrast.main',
            '&:hover': {
              bgcolor: 'primary.dark',
              color: '#fff',
            },
          }}
          variant="contained"
          onClick={this.onSave}
        >
          Save
        </Button>
      </Box>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  user: loggedInUser(state),
  organizations: getOrganizationsSorted(state),
});

const actionCreators = {
  updateUser,
  enqueueError,
};

export default connect(mapStateToProps, actionCreators)(EditSelf);
